
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {numeric, required, requiredIf} from "vuelidate/lib/validators";
import {Component} from "vue-property-decorator";
import {CashboxAddFormRequestType} from "@/form/finance/cashbox/CashboxAddForm.types";
import { fio, email } from "@/utils/validators";
import {ICashboxType, CashboxTypeResponseType} from "@/entity/finance/cashbox/cashboxType.types";

@Component
export default class CashboxAddForm extends Form{
    @Validate(required, i18nText("Введите название"))
    name = '';
    @Validate(required, i18nText("Выберите тип кассы3"))
    type = 1;
    comment = null;
    @Validate(required, i18nText("Введите начальный баланс кассы"))
    balance = '0';
    types: ICashboxType[] = [];
    salon_id: number | string | null = null;
    
    getFormData(): CashboxAddFormRequestType {
        return {
            name: this.name,
            type: this.type,
            balance: this.balance,
            comment: this.comment,
            salon_id: this.salon_id
        }
    }
    setFormData(types: ICashboxType[], salon_id?: number | string): void {
        if(salon_id){
            this.salon_id = salon_id;
        }

        this.types = [];
        for (let i = 0; i < types.length; i++) {
            if(!this.type){
                this.type = types[i].id;
            }
            this.types.push(types[i]);
        }
    }
}
